module.exports = __webpack_public_path__ + "static/media/Oct14-F19.9270a490.png";